module.exports = __webpack_public_path__ + "barre-jaune.png?70d2dd0b2f07cd81faea089a8209c771";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/barre-jaune.png
// module id = 145
// module chunks = 0